/**
 * Simple admin token store for the /admin dashboard.
 *
 * The admin panel is protected via Bearer JWT stored in localStorage.
 * On logout we just clear the token — the backend does not track sessions.
 */
const KEY = "lvp_admin_token";

export const getToken = () => {
  try {
    return localStorage.getItem(KEY) || null;
  } catch {
    return null;
  }
};

export const setToken = (token) => {
  try {
    if (token) localStorage.setItem(KEY, token);
    else localStorage.removeItem(KEY);
  } catch {
    /* ignore */
  }
};

export const clearToken = () => setToken(null);

export const authHeader = () => {
  const t = getToken();
  return t ? { Authorization: `Bearer ${t}` } : {};
};
